<dx-button text="Approve Registration" type="success" (onClick)="onApprovedClick($event)">
</dx-button>

<form-popup [(visible)]="isApprovedMerchantPopupOpened" titleText="Aproved" buttonSavedText="Approve Registration"
    (save)="onConfirmApprovedClick($event)">
    <div>
        Please make sure you checked the merchant and all requirements are met.
    </div>
</form-popup>